import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useHistory, useParams } from 'react-router-dom'
import ArrowSvg from '../../../../assets/images/arrow-back.svg'
import CameraSvg from '../../../../assets/images/camera.svg'
import CameraPurpleSvg from '../../../../assets/images/cameraPurple.svg'
import SignatureSvg from '../../../../assets/images/pencil.svg'
import SignaturePurpleSvg from '../../../../assets/images/pencilPurple.svg'
import UserSvg from '../../../../assets/images/user-photo.svg'
import UserPurpleSvg from '../../../../assets/images/user-photoPurple.svg'
import Layout from '../../../components/Provider/Layout'
import CustomButton from '../../../components/shared/CustomButton'
import CustomCamera from '../../../components/shared/CustomCamera'
import Loading from '../../../components/shared/Loading'
import { default as MessageModal, default as SimpleModal } from '../../../components/shared/MessageModal'
import Signature from '../../../components/shared/Signature'
import UploadButton from '../../../components/shared/UploadButton'
import { deliveryActions } from '../../../redux/actions'
import OrderService from '../../../services/OrderService'
import ProvidersService from '../../../services/ProviderServices'
import { getMessageFromError } from '../../../utils/error.services'
import './DeliveryDetail.scss'

function DeliveryDetail() {



  const [signature, setSignature] = useState(null)
  const [loading, setLoading] = useState(false)
  const [photo, setPhoto] = useState(null)
  const [currentScreen, setScreen] = useState(0)
  const [photo2, setPhoto2] = useState(null)
  const [successModal, setSuccessModal] = useState(false)
  const [modalWarning, setModalWarning] = useState(false)
  const [messageError, setMessageError] = useState('')
  const [messageSuccess, setMessageSuccess] = useState('')
  const [modalWarningConfirm, setModalWarningConfirm] = useState(false)
  const [modalNoInternet, setModalNoInternet] = useState(false)
  const history = useHistory()
  const { location: { state: { searching } } } = history
  let { id } = useParams()

  const deliveryReducer = useSelector(state => state.deliveryReducer)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(deliveryActions.setOc(id))
    console.log('DeliveryDetail -> Evidencias: ', deliveryReducer)
    const { clientPhoto, dniPhoto, sign } = deliveryReducer
    if (clientPhoto && dniPhoto && sign) {
      setSignature(sign)
      setPhoto(dniPhoto)
      setPhoto2(clientPhoto)
    }
  }, [])

  useEffect(() => {

    console.log('Inicio de entrega de pedidos');

    const load = async () => {

      try {

        const data = await OrderService.entregaInit(id);
        console.log(data.complete, data.message);

      } catch (error) {
        console.log('Error al iniciar la entrega de los productos:', error.message);
      }


    }

    load();

  }, [id]);

  const handlePicture = (image) => {
    // el image es un base64 png
    // console.log("DNI => ", image)

    if (image !== 'data:,') {
      setPhoto(image)
      dispatch(deliveryActions.setDniPhoto(image))
    } else {
      setPhoto(null)
      dispatch(deliveryActions.setDniPhoto(null))
    }
    setScreen(0)
  }

  const handlePicture2 = (image) => {
    // el image es un base64 png
    // console.log("Client => ", image)

    if (image !== 'data:,') {
      setPhoto2(image)
      dispatch(deliveryActions.setClientPhoto(image))
    } else {
      setPhoto2(null)
      dispatch(deliveryActions.setClientPhoto(null))
    }
    setScreen(0)
  }

  const handleSignature = (image) => {
    // el image es un base64 png
    // console.log("sign => ", image)

    if (image !== 'data:,') {
      setSignature(image)
      dispatch(deliveryActions.setSign(image))
    } else {
      setSignature(null)
      dispatch(deliveryActions.setSign(null))
    }

    // setSignature("image")
    // dispatch(deliveryActions.setSign("image"))

    setScreen(0)
  }

  const onCloseSignature = () => {
    setScreen(0)
  }

  const saveData = async () => {
    try {
      setLoading(true)
      const data = await ProvidersService.finalizeOc(id, photo, photo2, signature)
      console.log('data', data);
      validacionDeEntrega();
      // setTimeout(() => history.push('/entrega', {
      //   searching: searching
      // }), 2500)
    } catch (e) {
      console.log('e', getMessageFromError(e));
      dispatch(deliveryActions.cleanAll())
      setLoading(false)
      setMessageError(getMessageFromError(e).message);
      setModalWarning(true)
    }
  }

  const validacionDeEntrega = async () => {

    //Validamos que se haya entregado correctamente

    try {

      const data = await OrderService.entregaEnd(id);
      console.log(data);

      if (data.complete) {

        setMessageSuccess(data.message);
        setLoading(false)
        setSuccessModal(true)
        dispatch(deliveryActions.cleanAll())

      } else {

        throw new Error(data.message);

      }



    } catch (error) {
      console.log('Error al finalizar la entrega de los productos:', error.message);
      dispatch(deliveryActions.cleanAll())
      setLoading(false)
      setMessageError(getMessageFromError(error).message);
      setModalWarning(true)
    }




  }

  const renderScreen = () => {
    switch (currentScreen) {
      case 1:
        return (
          <CustomCamera
            handlePicture={handlePicture}
            onClose={() => setScreen(0)}
          />
        );
      case 2:
        return (
          <Layout>
            <Signature
              hasTwoButtons={true}
              onClose={onCloseSignature}
              onSend={handleSignature}
              message={
                "“Dejo constancia haber recibido de manera conforme el pedido detallado anteriormente.”"
              }
              btn1="CANCELAR"
              btn2="ACEPTAR"
            />
          </Layout>
        );
      case 3:
        return (
          <CustomCamera
            handlePicture={handlePicture2}
            onClose={() => setScreen(0)}
          />
        );
      default:
        return (
          <Layout>
            <Loading visible={loading} />
            <MessageModal
              visible={successModal}
              closeModal={() => {}}
              type={11}
              title="Pedido entregado con exito"
              txtBtn1="Aceptar"
              onClickBtn1={() => {
                history.push("/entrega", { searching: searching });
              }}
            >
              <div>
                <p>Se entregó el pedido N° {id}</p>
                <p>{messageSuccess}</p>
              </div>
            </MessageModal>
            <SimpleModal
              visible={modalWarningConfirm}
              txtBtn1="VOLVER"
              onClickBtn1={() => {
                setModalWarningConfirm(false);
              }}
              txtBtn2={"CONFIRMAR"}
              onClickBtn2={() => {
                setModalWarningConfirm(false);
                saveData();
              }}
              type={10}
              closeModal={() => setModalWarning(false)}
              title={"¿Seguro que deseas finalizar?"}
            >
              <div className="modal-warning-message">
                <p>
                  Una vez finalizado el proceso, <span>no podrás editar</span>{" "}
                  los datos de validación.
                </p>
              </div>
            </SimpleModal>
            <MessageModal
              visible={modalWarning}
              closeModal={() => setModalWarning(false)}
              message={messageError}
              type={21}
            />
            <div className="delivery-detail-container">
              <div className="delivery-detail-body">
                <div className="delivery-detail-header">
                  <Link
                    to={{
                      pathname: "/entrega",
                      state: {
                        searching: searching,
                      },
                    }}
                    style={{ display: "flex" }}
                  >
                    <img src={ArrowSvg} alt="atras" />
                  </Link>
                  <h3>Validación de entrega</h3>
                </div>
                <div className="delivery-detail-buttons">
                  <div className="button-container">
                    <UploadButton
                      image={photo ? CameraPurpleSvg : CameraSvg}
                      text="FOTO DE CODIGO QR"
                      isCompleted={photo}
                      onClick={() => setScreen(1)}
                    />
                  </div>
                  <div className="button-container">
                    <UploadButton
                      image={photo2 ? UserPurpleSvg : UserSvg}
                      text="FOTO DE PEDIDO (Sin rostro)"
                      isCompleted={photo2}
                      onClick={() => setScreen(3)}
                    />
                  </div>
                  <div className="button-container">
                    <UploadButton
                      image={signature ? SignaturePurpleSvg : SignatureSvg}
                      text="FIRMA DIGITAL"
                      isCompleted={signature}
                      onClick={() => setScreen(2)}
                    />
                  </div>
                </div>
              </div>
              <div className="delivery-detail-footer">
                <CustomButton
                  margin="0"
                  onClick={() =>
                    history.push("/entrega", {
                      searching: searching,
                    })
                  }
                >
                  CANCELAR
                </CustomButton>
                <CustomButton
                  filled={true}
                  margin="0"
                  disabled={!signature || !photo || !photo2}
                  onClick={() => setModalWarningConfirm(true)}
                >
                  FINALIZAR
                </CustomButton>
              </div>
            </div>
          </Layout>
        );
    }
  }

  return renderScreen()
}

export default DeliveryDetail
